import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { bootstrap } from './bootstrap';
import {
  fetchLoginRequired,
  sessionTokenKey,
  SplashGate,
  validateSessionToken,
} from './ui/SplashGate';
import { ws } from './ws/client';
import './styles.css';

function Root(): React.ReactNode {
  const [phase, setPhase] = useState<'loading' | 'login' | 'app'>('loading');

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const required = await fetchLoginRequired();
      if (cancelled) return;
      if (!required) {
        bootstrap();
        setPhase('app');
        return;
      }
      const existing = sessionStorage.getItem(sessionTokenKey()) || '';
      if (existing && (await validateSessionToken(existing))) {
        if (cancelled) return;
        bootstrap();
        setPhase('app');
        return;
      }
      sessionStorage.removeItem(sessionTokenKey());
      ws.disconnect();
      if (!cancelled) setPhase('login');
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (phase === 'loading') {
    return <div className="splash splash-loading">Loading…</div>;
  }
  if (phase === 'login') {
    return (
      <SplashGate
        onUnlocked={() => {
          bootstrap();
          setPhase('app');
        }}
      />
    );
  }
  return <App />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
